module.exports = __webpack_public_path__ + "img/help6.bbf0781e.png";